const dict = {
  uk: {
    days: {
      mon: 'Понеділок',
      tue: 'Вівторок',
      wed: 'Середа',
      thu: 'Четвер',
      fri: "П'ятниця",
      sat: 'Субота',
      sun: 'Неділя',
      monShort: 'Пн',
      tueShort: 'Вт',
      wedShort: 'Ср',
      thuShort: 'Чт',
      friShort: 'Пт',
      satShort: 'Сб',
      sunShort: 'Нд',
    },
    subtitles: {
      consultation: 'Методист зателефонує вам у зручний час та допоможе обрати програму',
      individual: 'Оберіть 2-3 дні на тиждень для стабільного прогресу',
      group: 'Групові заняття проходять за фіксованим розкладом',
    },
    levels: {
      starter: 'Нульовий',
      starterDesc: 'Знаю лише кілька слів',
      a1: 'Початковий (A1)',
      a1Desc: 'Розумію прості фрази',
      a2: 'Базовий (A2)',
      a2Desc: 'Можу спілкуватися на прості теми',
      b1: 'Середній (B1)',
      b1Desc: 'Розумію основний зміст текстів',
      b2: 'Вище середнього (B2)',
      b2Desc: 'Вільно спілкуюсь на різні теми',
      c1: 'Просунутий (C1)',
      c1Desc: 'Майже вільно володію мовою',
    },
    phone: {
      enterNumber: 'Введіть номер телефону',
      digits9After380: 'Номер має містити 9 цифр після +380',
      invalidOperator: 'Невірний код оператора',
      digits9After380NoSign: 'Номер має містити 9 цифр після 380',
      digits10From0: 'Номер має містити 10 цифр (починаючи з 0)',
      mustStartWith: 'Номер має починатися з +380, 380 або 0',
    },
    stepLabels: {
      level: 'Рівень',
      pathSelect: 'Вибір шляху',
      levelManual: 'Рівень',
      consultation: 'Консультація',
      typeSelect: 'Тип навчання',
      details: 'Деталі запису',
      payment: 'Оплата',
    },
    errors: {
      codeExpired: 'Код прострочений. Спробуйте ще раз.',
      createCode: 'Помилка створення коду',
      chooseLevel: 'Оберіть рівень',
      saveLevel: 'Помилка збереження рівня',
      confirmPhone: 'Спочатку підтвердіть номер телефону',
      chooseDateTime: 'Оберіть дату та час консультації',
      notSpecified: 'Не вказано',
      createRequest: 'Помилка створення заявки',
      consultBookError: 'Помилка при бронюванні консультації',
      enterPromo: 'Введіть промокод',
      activatePromoFailed: 'Не вдалося активувати промокод',
      chooseDaysTeacher: 'Оберіть дні занять та викладача',
      chooseAllTimes: 'Оберіть час для всіх обраних днів',
      passLevelFirst: 'Спочатку пройдіть тест на визначення рівня',
      programNotFound: 'Підходящу програму не знайдено',
      enrollError: 'Помилка при записі на заняття',
      chooseGroup: 'Оберіть групу',
      groupFull: 'Група заповнена. Оберіть іншу групу або запишіться на індивідуальні заняття.',
      alreadyInGroup: 'Ви вже записані до цієї групи.',
      groupEnrollError: 'Помилка при записі до групи',
    },
    alerts: {
      consultSent: "Заявку на консультацію надіслано! Ми зв'яжемося з вами найближчим часом.",
      enrolledIndividual: 'Ви успішно записались на індивідуальні заняття!',
      enrolledGroup: 'Ви успішно записались до групи "{{name}}"!',
    },
    header: {
      pathSelect: 'Запис на навчання',
      levelConfirm: 'Підтвердіть рівень',
      levelManual: 'Оберіть свій рівень',
      typeSelect: 'Тип навчання',
      consultation: 'Запис на консультацію',
      individual: 'Індивідуальні заняття',
      group: 'Групові заняття',
      payment: 'Оплата навчання',
      success: 'Готово!',
    },
    path: {
      yourLevel: 'Ваш рівень англійської',
      testPassedIntro: 'Як ви хочете обрати програму навчання?',
      testNotPassedIntro: 'Оберіть, як зручніше почати. Тест проходити не обов’язково.',
      chooseSelf: 'Обрати програму самостійно',
      chooseSelfDesc: 'Оберіть зручний час, викладача та тип навчання',
      bookConsult: 'Записатися на консультацію',
      bookConsultDesc: 'Наш методист допоможе підібрати оптимальну програму',
      chooseLevelSelf: 'Обрати свій рівень самостійно',
      chooseLevelSelfDesc: 'Знаю свій рівень — обрати зі списку і одразу перейти до запису',
      shortTest: 'Пройти короткий тест',
      shortTestDesc: '10-15 хвилин — швидка перевірка слухання та читання',
      fullTest: 'Пройти повний тест',
      fullTestDesc: '30-45 хв — найточніше визначення рівня',
      phoneConsult: 'Записатися на телефонну консультацію',
      phoneConsultDesc: 'Методист зателефонує, визначить рівень і допоможе з вибором',
    },
    levelConfirm: {
      current: 'Ваш поточний рівень',
      agree: 'Погоджуєтесь із цим рівнем?',
      yes: 'Так, погоджуюсь',
      no: 'Ні, змінити рівень',
      quickTest: 'Пройти швидкий тест',
      quickTestDesc: '10-15 хвилин — швидка перевірка слухання та читання',
      fullTest: 'Пройти повний тест',
      fullTestDesc: '30-45 хв — найточніше визначення рівня',
      setManually: 'Виставити рівень самостійно',
      setManuallyDesc: 'Знаю свій рівень — обрати зі списку',
      bookConsult: 'Записатися на консультацію',
      bookConsultDesc: 'Методист допоможе підібрати програму',
      back: 'Назад',
    },
    levelManual: {
      intro: 'Оберіть свій рівень англійської — його завжди можна змінити пізніше в кабінеті.',
      saving: 'Зберігаємо...',
      next: 'Далі',
    },
    typeSelect: {
      pickFormat: 'Оберіть формат навчання',
      individualTitle: 'Індивідуальне навчання',
      individualDesc: 'Персональні заняття з викладачем. Гнучкий графік, індивідуальний підхід.',
      groupTitle: 'Групове навчання',
      groupDesc: 'Заняття у групі до 8 осіб. Спілкування з однолітками, вигідніша ціна.',
    },
    consult: {
      leaveRequest: 'Залиште заявку на консультацію з методистом',
      phoneLabel: 'Номер телефону',
      phoneConfirmed: 'Номер підтверджено',
      changeBtn: 'Змінити',
      confirmViaTelegram: 'Підтвердити через Telegram',
      confirmInTelegram: 'Підтвердіть номер у Telegram',
      sendCodeToBot: 'Натисніть кнопку нижче і надішліть код боту',
      yourCode: 'Ваш код верифікації:',
      openTelegram: 'Відкрити Telegram',
      waitingConfirmation: 'Очікуємо підтвердження...',
      changeOrRetry: 'Змінити номер або спробувати знову',
      consultDate: 'Дата консультації',
      consultTime: 'Час консультації (7:00 - 22:00)',
      chosen: 'Обрано:',
      chosenFormat: '{{date}} о {{time}}',
      sending: 'Надсилаємо...',
      submitRequest: 'Надіслати заявку на консультацію',
    },
    individual: {
      pickDays: 'Оберіть дні занять',
      timeFor: 'Час для {{day}}',
      pickTeacher: 'Оберіть викладача',
      loadingTeachers: 'Завантаження викладачів...',
      noTeachers: 'На обраний час немає вільних викладачів',
      tryOther: 'Спробуйте обрати інший час або зверніться на консультацію',
      lessonsCount: '{{count}} уроків',
      program: 'Програма навчання',
      autoPickedByLevel: 'Курс {{level}} - автоматично підібрано за вашим рівнем',
      termsAcceptPrefix: 'Я прочитав(-ла) та приймаю',
      terms: 'Умови надання послуг',
      termsSuffix: ', зокрема правила оплати, скасування, перенесення занять і повернення коштів.',
      nextToPayment: 'Далі до оплати',
    },
    group: {
      showingForLevel: 'Показуємо групи для рівня',
      noGroupsForLevel: 'Немає доступних груп для рівня {{level}}',
      consultOrIndividual: 'Зверніться на консультацію або оберіть індивідуальне навчання',
      backToChoice: 'Повернутися до вибору',
      teacherLine: 'Викладач: {{name}}',
      startDate: 'Старт: {{date}}',
      termsAcceptPrefix: 'Я прочитав(-ла) та приймаю',
      terms: 'Умови надання послуг',
      termsSuffix: ', зокрема правила оплати, скасування, перенесення занять і повернення коштів.',
      nextToPayment: 'Далі до оплати',
    },
    payment: {
      costTitle: 'Вартість навчання',
      oneLesson: 'Одне заняття',
      currencyPerLesson: '{{amount}} грн',
      packageLine: 'Пакет ({{count}} занять / місяць)',
      dueNow: 'До сплати зараз',
      groupNote: 'Групові заняття оплачуються раз на місяць наперед — одразу за весь пакет із {{count}} занять.',
      firstLesson: 'Перше заняття',
      individualNote: 'Індивідуальні заняття оплачуються окремо за кожне. Зараз списується вартість лише першого заняття, наступні — перед кожним уроком.',
      yourBalance: 'Ваш баланс',
      freeLessons: 'Безкоштовні заняття',
      usingSomeFree: 'Буде використано {{count}} безкоштовних занять. Решта — {{amount}} грн — спишеться з балансу.',
      usingAllFree: 'Заняття покриється безкоштовним уроком з промокоду — платити нічого не треба.',
      autoDebit: 'З вашого балансу автоматично спишеться {{amount}} грн одразу після підтвердження.',
      insufficient: 'На балансі недостатньо коштів (потрібно {{needed}} грн, є {{have}} грн). Поповніть баланс або скористайтесь промокодом — інакше запис не буде підтверджено.',
      hold24h: 'Місце буде заброньовано на 24 години. Оплатіть {{amount}} грн протягом цього часу (поповнення балансу або промокод), інакше бронювання скасується автоматично.',
      promoTitle: 'Промокод',
      promoIntro: 'Введіть промокод на безкоштовне пробне або безкоштовний урок.',
      promoActivated: 'Промокод {{code}} активовано',
      freeLessonsAdded: '+{{count}} безкоштовних занять',
      balanceAdded: '+{{amount}} грн на баланс',
      enterCode: 'Введіть код',
      activate: 'Активувати',
      topupHint: 'Поповнити баланс можна у розділі «Баланс» — після оплати місце автоматично підтвердиться.',
      processing: 'Обробка...',
      confirmEnroll: 'Підтвердити запис',
    },
    success: {
      consultScheduledOn: 'Консультація запланована на:',
      details: 'Деталі запису:',
      program: 'Програма:',
      teacher: 'Викладач:',
      level: 'Рівень:',
      lessonsCreated: 'Створено {{count}} уроків у розкладі',
      schedule: 'Розклад:',
      scheduleLine: '{{day}} о {{time}}',
      enrolledInGroup: 'Ви записались до групи:',
      teacherLine: 'Викладач: {{name}}',
      done: 'Готово',
    },
    misc: {
      lessonN: 'Урок {{n}}',
    },
  },
  en: {
    days: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
      monShort: 'Mon',
      tueShort: 'Tue',
      wedShort: 'Wed',
      thuShort: 'Thu',
      friShort: 'Fri',
      satShort: 'Sat',
      sunShort: 'Sun',
    },
    subtitles: {
      consultation: 'A methodologist will call you at a convenient time and help you pick a program',
      individual: 'Pick 2-3 days per week for steady progress',
      group: 'Group lessons follow a fixed schedule',
    },
    levels: {
      starter: 'Zero',
      starterDesc: 'I only know a few words',
      a1: 'Beginner (A1)',
      a1Desc: 'I understand simple phrases',
      a2: 'Elementary (A2)',
      a2Desc: 'I can talk about simple topics',
      b1: 'Intermediate (B1)',
      b1Desc: 'I understand the main idea of texts',
      b2: 'Upper-intermediate (B2)',
      b2Desc: 'I speak fluently on various topics',
      c1: 'Advanced (C1)',
      c1Desc: 'I speak the language almost fluently',
    },
    phone: {
      enterNumber: 'Enter your phone number',
      digits9After380: 'Number must have 9 digits after +380',
      invalidOperator: 'Invalid operator code',
      digits9After380NoSign: 'Number must have 9 digits after 380',
      digits10From0: 'Number must have 10 digits (starting with 0)',
      mustStartWith: 'Number must start with +380, 380 or 0',
    },
    stepLabels: {
      level: 'Level',
      pathSelect: 'Path',
      levelManual: 'Level',
      consultation: 'Consultation',
      typeSelect: 'Learning type',
      details: 'Enrollment details',
      payment: 'Payment',
    },
    errors: {
      codeExpired: 'Code expired. Please try again.',
      createCode: 'Failed to create code',
      chooseLevel: 'Choose a level',
      saveLevel: 'Failed to save level',
      confirmPhone: 'First confirm your phone number',
      chooseDateTime: 'Choose consultation date and time',
      notSpecified: 'Not specified',
      createRequest: 'Failed to create request',
      consultBookError: 'Error booking consultation',
      enterPromo: 'Enter a promo code',
      activatePromoFailed: 'Could not activate promo code',
      chooseDaysTeacher: 'Choose lesson days and a teacher',
      chooseAllTimes: 'Choose a time for all selected days',
      passLevelFirst: 'First take the level test',
      programNotFound: 'No suitable program found',
      enrollError: 'Error enrolling in lessons',
      chooseGroup: 'Choose a group',
      groupFull: 'The group is full. Choose another group or enroll in individual lessons.',
      alreadyInGroup: 'You are already enrolled in this group.',
      groupEnrollError: 'Error enrolling in the group',
    },
    alerts: {
      consultSent: 'Consultation request sent! We will contact you shortly.',
      enrolledIndividual: 'You have successfully enrolled in individual lessons!',
      enrolledGroup: 'You have successfully joined the group "{{name}}"!',
    },
    header: {
      pathSelect: 'Enroll in learning',
      levelConfirm: 'Confirm your level',
      levelManual: 'Choose your level',
      typeSelect: 'Learning type',
      consultation: 'Book a consultation',
      individual: 'Individual lessons',
      group: 'Group lessons',
      payment: 'Payment',
      success: 'Done!',
    },
    path: {
      yourLevel: 'Your English level',
      testPassedIntro: 'How would you like to pick a program?',
      testNotPassedIntro: 'Pick whichever way is easier. The test is optional.',
      chooseSelf: 'Pick a program on my own',
      chooseSelfDesc: 'Choose time, teacher and lesson type',
      bookConsult: 'Book a consultation',
      bookConsultDesc: 'Our methodologist will help you pick the best program',
      chooseLevelSelf: 'Pick my level on my own',
      chooseLevelSelfDesc: 'I know my level — pick from the list and go straight to enrollment',
      shortTest: 'Take a short test',
      shortTestDesc: '10-15 minutes — quick listening and reading check',
      fullTest: 'Take the full test',
      fullTestDesc: '30-45 min — most precise level assessment',
      phoneConsult: 'Book a phone consultation',
      phoneConsultDesc: 'A methodologist will call, assess your level and help you choose',
    },
    levelConfirm: {
      current: 'Your current level',
      agree: 'Do you agree with this level?',
      yes: 'Yes, I agree',
      no: 'No, change level',
      quickTest: 'Take a quick test',
      quickTestDesc: '10-15 minutes — quick listening and reading check',
      fullTest: 'Take the full test',
      fullTestDesc: '30-45 min — most precise level assessment',
      setManually: 'Set my level manually',
      setManuallyDesc: 'I know my level — pick from the list',
      bookConsult: 'Book a consultation',
      bookConsultDesc: 'A methodologist will help pick the program',
      back: 'Back',
    },
    levelManual: {
      intro: 'Pick your English level — you can always change it later in your account.',
      saving: 'Saving...',
      next: 'Next',
    },
    typeSelect: {
      pickFormat: 'Choose the learning format',
      individualTitle: 'Individual learning',
      individualDesc: 'One-on-one lessons with a teacher. Flexible schedule, personal approach.',
      groupTitle: 'Group learning',
      groupDesc: 'Lessons in a group of up to 8 people. Peer interaction, better price.',
    },
    consult: {
      leaveRequest: 'Leave a request for a consultation with a methodologist',
      phoneLabel: 'Phone number',
      phoneConfirmed: 'Number confirmed',
      changeBtn: 'Change',
      confirmViaTelegram: 'Confirm via Telegram',
      confirmInTelegram: 'Confirm the number in Telegram',
      sendCodeToBot: 'Tap the button below and send the code to the bot',
      yourCode: 'Your verification code:',
      openTelegram: 'Open Telegram',
      waitingConfirmation: 'Waiting for confirmation...',
      changeOrRetry: 'Change the number or try again',
      consultDate: 'Consultation date',
      consultTime: 'Consultation time (7:00 - 22:00)',
      chosen: 'Chosen:',
      chosenFormat: '{{date}} at {{time}}',
      sending: 'Sending...',
      submitRequest: 'Send consultation request',
    },
    individual: {
      pickDays: 'Choose lesson days',
      timeFor: 'Time for {{day}}',
      pickTeacher: 'Choose a teacher',
      loadingTeachers: 'Loading teachers...',
      noTeachers: 'No teachers available for the selected time',
      tryOther: 'Try a different time or book a consultation',
      lessonsCount: '{{count}} lessons',
      program: 'Learning program',
      autoPickedByLevel: 'Course {{level}} — auto-picked for your level',
      termsAcceptPrefix: 'I have read and accept the',
      terms: 'Terms of service',
      termsSuffix: ', including payment, cancellation, rescheduling and refund rules.',
      nextToPayment: 'Next to payment',
    },
    group: {
      showingForLevel: 'Showing groups for level',
      noGroupsForLevel: 'No available groups for level {{level}}',
      consultOrIndividual: 'Book a consultation or choose individual lessons',
      backToChoice: 'Back to selection',
      teacherLine: 'Teacher: {{name}}',
      startDate: 'Start: {{date}}',
      termsAcceptPrefix: 'I have read and accept the',
      terms: 'Terms of service',
      termsSuffix: ', including payment, cancellation, rescheduling and refund rules.',
      nextToPayment: 'Next to payment',
    },
    payment: {
      costTitle: 'Learning cost',
      oneLesson: 'One lesson',
      currencyPerLesson: '{{amount}} UAH',
      packageLine: 'Package ({{count}} lessons / month)',
      dueNow: 'Due now',
      groupNote: 'Group lessons are paid once per month in advance — the whole package of {{count}} lessons at once.',
      firstLesson: 'First lesson',
      individualNote: 'Individual lessons are paid separately for each. Only the cost of the first lesson is charged now; the rest — before each lesson.',
      yourBalance: 'Your balance',
      freeLessons: 'Free lessons',
      usingSomeFree: '{{count}} free lessons will be used. The remainder — {{amount}} UAH — will be charged from balance.',
      usingAllFree: 'The lesson is covered by a free lesson from your promo code — nothing to pay.',
      autoDebit: '{{amount}} UAH will be automatically charged from your balance right after confirmation.',
      insufficient: 'Insufficient balance (need {{needed}} UAH, have {{have}} UAH). Top up your balance or use a promo code — otherwise the enrollment will not be confirmed.',
      hold24h: 'The spot will be held for 24 hours. Pay {{amount}} UAH within that time (balance top-up or promo code), otherwise the booking will be cancelled automatically.',
      promoTitle: 'Promo code',
      promoIntro: 'Enter a promo code for a free trial or a free lesson.',
      promoActivated: 'Promo code {{code}} activated',
      freeLessonsAdded: '+{{count}} free lessons',
      balanceAdded: '+{{amount}} UAH to balance',
      enterCode: 'Enter code',
      activate: 'Activate',
      topupHint: 'You can top up the balance in the "Balance" section — after payment the spot is confirmed automatically.',
      processing: 'Processing...',
      confirmEnroll: 'Confirm enrollment',
    },
    success: {
      consultScheduledOn: 'Consultation scheduled for:',
      details: 'Enrollment details:',
      program: 'Program:',
      teacher: 'Teacher:',
      level: 'Level:',
      lessonsCreated: '{{count}} lessons created in the schedule',
      schedule: 'Schedule:',
      scheduleLine: '{{day}} at {{time}}',
      enrolledInGroup: 'You joined the group:',
      teacherLine: 'Teacher: {{name}}',
      done: 'Done',
    },
    misc: {
      lessonN: 'Lesson {{n}}',
    },
  },
};

export default dict;
